import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has been stable for `delayMs`. Generic
 * debounce for search-as-you-type inputs feeding React Query — the
 * debounced value goes in the query key, so keystrokes inside the
 * window never issue a request.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
